import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { isAuth, user, subscribed, isAuthSU, encodedAuth } = useAuth();
  const location = useLocation();

  if (!isAuth || !user) {
    // Redirect to login if not authenticated
    if (isAuthSU) {
      return <Navigate to="/super-user" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // Only check subscription status if we're NOT on the catalog page
  if (!subscribed && location.pathname !== "/catalog") {
    // Redirect to pricing if not subscribed
    return <Navigate to="/pricing" replace />;
  }

  if (!encodedAuth || encodedAuth === null || encodedAuth === "null") {
    // Redirect to account if no encoded auth exists
    return <Navigate
      to="/account"
      state={{
        error: "Please connect your Walmart account to use Inventory Falcon."
      }}
      replace
    />
  }
  return children;
};